import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import React from 'react';
import { Modal, Platform } from "react-native";

export default function ModalBase(props) {

    const webProps = Platform.OS == 'web' ? { maxWidth: 390, width: '100%', maxHeight: 844, height: '100%', margin: 'auto', overflow: 'hidden' } : {}
    return (
        <Modal visible={props.showModal} statusBarTranslucent={true} transparent={true}>
            <View {...webProps} className="flex-1 bg-[#00000050] justify-center">
                <VStack space='md' className={` ${props.h ? props.h : ''} alignItems-${props.alignItems} m-3 bg-secondary-50 px-4 py-5 rounded-[5px] `}>
                    {props.children}
                </VStack>
            </View>
        </Modal>
    );
}